
import { IAppSettings } from './appSettings.types'

/** class for app settings */
export class AppSettings implements IAppSettings {

    readonly MaxFileLimit: number
    readonly MaxFileSizeLimit: number
    readonly EnableMigrationImport: boolean
    readonly EnableGrantAmendment: boolean

    constructor (data: IAppSettings) {
    
        this.MaxFileLimit = data.MaxFileLimit;
        this.MaxFileSizeLimit = data.MaxFileSizeLimit;
        this.EnableMigrationImport = data.EnableMigrationImport;
        this.EnableGrantAmendment = data.EnableGrantAmendment;
    }
}